var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('standart-card',{staticClass:"relative",attrs:{"title":"STATUT DES APPAREILS","height":"375px"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('v-icon',{staticClass:"display_cog",on:{"click":_vm.shouldDisplayParamModal}},[_vm._v("mdi-cog-outline")])]},proxy:true}])},[(_vm.should_display_params)?_c('DeviceStateModal',{attrs:{"should_display":_vm.should_display_params,"onClose":_vm.shouldCloseParamModal,"onValidate":_vm.setItemToDisplay,"status_list":_vm.state_to_display}}):_vm._e(),_c('div',[_c('doughnut-chart',{attrs:{"styles":{ height: '300px' },"chart-data":_vm.data,"options":{
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontColor: '#ffffff'
          },
          position: 'left'
        }
      }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }